export const FORM_TYPES = {
  ADD: 'ADD',
  COLOR: 'COLOR',
  COMMENT: 'COMMENT',
  CONFIRM: 'CONFIRM',
  CONFIRM_SAVE: 'CONFIRM_SAVE',
  CONFIRM_SUBMIT: 'CONFIRM_SUBMIT',
  DELETE: 'DELETE',
  DRAG_TITLES: 'DRAG_TITLES',
  DUPLICATE: 'DUPLICATE',
  EDIT: 'EDIT',
  EXPORT: 'EXPORT',
  EXPORT_INTERACTIVE: 'EXPORT_INTERACTIVE',
  IMPORT_FORM: 'IMPORT_FORM',
  INSERT: 'INSERT',
  OP2MISE: 'OP2MISE',
  PRESENTATION_GENERATE: 'PRESENTATION_GENERATE',
  PASTE: 'PASTE',
  SUBMIT: 'SUBMIT',
  SHUNT: 'SHUNT',
};

export const SCHEDULE_PAGES = {
  LANDING: 'LANDING',
  SCHEDULER: 'SCHEDULER',
  PLAYLIST: 'PLAYLIST',
  VERSION: 'VERSION',
};

export const BUTTONS = {
  CREATE: 'create',
  OP2MISE: 'op2mise',
  SAVE: 'save',
  SUBMIT: 'submit',
  VIEW: 'view',
  VERSION: 'version',
};

export const SCHEDULE_TYPE = {
  ADVANCED: 'Advanced',
  NEW: 'New',
  STANDBY: 'Standby',
};
